import client from './client';

// Local (evolve) patient resolved from an athenaOne patient id, or null when
// no matching patient exists.
export type ResolvedAthenaPatient = { id: number } | null;

// Resolves an athenaOne patient id to the local patient via the patients
// service (`GET /api/patients?athenaId=...`).
export const resolvePatientByAthenaId = (athenaId: string) => client().get<ResolvedAthenaPatient>('/patients', { params: { athenaId } });
